import { Experiments, useExperiment } from "@tenant/experiments";

export const useIsHtsAssistEnabled = (): boolean => {
  const { isExperimentVariant } = useExperiment();

  return isExperimentVariant(
    Experiments.HTS_ASSIST_ENABLED.name,
    Experiments.HTS_ASSIST_ENABLED.variants.available
  );
};
